import { NodeSpec } from 'prosemirror-model';

import ListItem from '../ListItem';

export default class InlineEditorListItem extends ListItem {
  get schema(): NodeSpec {
    return {
      ...this._schema,
      toDOM: () => ['li', 0],
    };
  }
}
